import "core-js/modules/es.array.index-of";

/*
 * Copyright (c) 2019 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import NavigationItemRecord from '../../../../records/NavigationItemRecord';

var addRequestParams = function addRequestParams(url, paramsString) {
  return url + (url.indexOf('?') === -1 ? '?' : '&') + paramsString;
};

export default (function (navigationResponse) {
  var _ref = navigationResponse.linkNavigationViewBean || navigationResponse || {},
      displayType = _ref.displayType,
      url = _ref.url,
      browserMode = _ref.browserMode,
      confirmRequired = _ref.confirmRequired,
      requestParams = _ref.requestParams,
      _ref$linkStaticConfig = _ref.linkStaticConfig,
      linkStaticConfig = _ref$linkStaticConfig === void 0 ? {} : _ref$linkStaticConfig;

  var _linkStaticConfig$lin = linkStaticConfig.linkNonSamlAttributes,
      linkNonSamlAttributes = _linkStaticConfig$lin === void 0 ? {} : _linkStaticConfig$lin,
      _linkStaticConfig$lin2 = linkStaticConfig.linkSamlAttributes,
      linkSamlAttributes = _linkStaticConfig$lin2 === void 0 ? {} : _linkStaticConfig$lin2;
  var linkAttribute = displayType === 'saml' ? linkSamlAttributes : linkNonSamlAttributes;
  var navigationUrl = requestParams ? addRequestParams(url, requestParams) : url;
  return new NavigationItemRecord({
    navigationUrl: navigationUrl,
    displayType: displayType,
    nativeNavigationType: 'external',
    externalNavigation: 'external' === linkAttribute['data-link-type'] || confirmRequired === 'confirm-dispatch',
    forceWindow: 'true' === linkAttribute['data-force-window'] || browserMode === 'externalBrowser'
  });
});